module.exports = __webpack_public_path__ + "img/plus-btn.fb2c47ad.svg";